// src/components/HireMe.jsx

export default function HireMe() {
  const handleHireMeClick = (e) => {
    e.preventDefault();
    const el = document.getElementById('contact');
    if (el) {
      const yOffset = -70;
      const y = el.getBoundingClientRect().top + window.pageYOffset + yOffset;
      window.scrollTo({ top: y, behavior: 'smooth' });
    }
  };

  return (
    <section className="section-sm bg-primary text-white" id="hire-me">
      <div className="container">
        <div className="flex flex-col sm:flex-row items-center justify-between text-center sm:text-left gap-6 px-4">
          <div className="mb-2 sm:mb-0">
            <h5 className="font-heading text-2xl md:text-3xl text-white font-bold mb-1">
              Want to work with me?
            </h5>
            <p className="m-0 text-white opacity-90 text-sm md:text-base">
              Always feel free to contact & hire me for your mobile app projects.
            </p>
          </div>
          <div>
            <a
              href="#contact"
              onClick={handleHireMeClick}
              className="btn btn-lg btn-light rounded shadow-md whitespace-nowrap"
            >
              Hire Me
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
